// eslint-disable-next-line import/no-anonymous-default-export
import common from './common';
import settings from './settings';
import currency from './currency';
import users from './users';
import menu from './menu';
import sidebar from './sidebar';
import navbar from './navbar';
import accountTracking from './accountTracking';
import calendar from './calendar';
import companyPayments from './companyPayments';
import servers from './servers';
import registrars from './registrars';
import customers from './customers';
import domains from './domains';
import companies from './companies';
import dashboard from './dashboard';
import domainPrices from './domainPrices';
import hostingPrices from './hostingPrices';
import panels from './panels';
import maps from './maps';
import dataManagement from './dataManagement';
import languages from './languages';
import paymentAnalysis from './paymentAnalysis';
import recurringPaymentsAnalysis from './recurringPaymentsAnalysis';
import login from './login';
import auth from './auth';
import coordinates from './coordinates';
import locationSelector from './locationSelector';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common,
  settings,
  currency,
  users,
  menu,
  sidebar,
  navbar,
  accountTracking,
  calendar,
  companyPayments,
  servers,
  registrars,
  customers,
  domains,
  companies,
  dashboard,
  domainPrices,
  hostingPrices,
  panels,
  maps,
  dataManagement,
  languages,
  paymentAnalysis,
  recurringPaymentsAnalysis,
  login,
  auth,
  coordinates,
  locationSelector
};
